export default __webpack_public_path__ + "assets/alert-circle-component.4d457c25.svg";